import { render, staticRenderFns } from "./VenueManage.vue?vue&type=template&id=38ab6ace&scoped=true"
import script from "./VenueManage.vue?vue&type=script&lang=js"
export * from "./VenueManage.vue?vue&type=script&lang=js"
import style0 from "./VenueManage.vue?vue&type=style&index=0&id=38ab6ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab6ace",
  null
  
)

export default component.exports